module.exports = __webpack_public_path__ + "img/thumbnail_StripedHyena_f_normal.59c3a42f.png";